export enum FamiliaEstado {
  pendienteDoc = "PENDIENTE_DOCUMENTACION",
  apto = "APTO",
  suspendido = "SUSPENDIDO",
}
